"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGetBulkActivityUsers = exports.mockGetActivities = void 0;
exports.mockGetActivities = {
    activities: [
        {
            performedBy: {
                email: 'user1@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/200',
            },
            action: 'logged_in',
            entity: 'user',
            time: new Date(),
            activity: '<userEmail> logged in',
            userEmail: 'user1@codebashing.com',
        },
        {
            performedBy: {
                email: 'user1@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/200',
            },
            action: 'start',
            entity: 'lesson',
            time: new Date(),
            activity: '<userEmail> started the lesson <lessonName> in the <courseName> course',
            userEmail: 'user1@codebashing.com',
            lessonName: 'SQL Injection',
            courseName: 'Java',
        },
        {
            performedBy: {
                email: 'user1@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/200',
            },
            action: 'complete',
            entity: 'lesson',
            time: new Date(),
            activity: '<userEmail> completed the lesson <lessonName> in the <courseName> course',
            userEmail: 'user1@codebashing.com',
            lessonName: 'SQL Injection',
            courseName: 'Java',
        },
        {
            performedBy: {
                email: 'user1@codebashing.com',
                profilePictureUrl: 'https://codebashing-dev-images.s3.eu-west-1.amazonaws.com/profile-pictures/learning-panel/d93e21f3-0a4a-4336-9a3c-d457180a7429/profile-picture/1701158520.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=AKIA3BZWI2TVONGAQQGR%2F20240220%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20240220T091405Z&X-Amz-Expires=900&X-Amz-Signature=82b469472999337380467bca0f6cd00cd76e808e573c76a87d0e5d5042aed21a&X-Amz-SignedHeaders=host&x-id=GetObject',
            },
            action: 'delete',
            entity: 'users',
            time: '2024-02-14T16:50:21.000Z',
            activity: '<adminEmail> deleted <N> users',
            userEmail: 'user1@code.com',
            adminEmail: 'user1@codebashing.com',
            totalUsers: 12,
            batchUuid: '6a7473c7-ea07-47a7-9416-acbf72eeb9a7',
            confirmedUserDeleted: 10,
        },
        {
            performedBy: {
                email: 'user2@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/201',
            },
            action: 'logged_in',
            entity: 'user',
            time: new Date(),
            activity: '<userEmail> logged in',
            userEmail: 'user2@codebashing.com',
        },
        {
            performedBy: {
                email: 'user2@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/201',
            },
            action: 'invite',
            entity: 'users',
            time: new Date(),
            activity: '<adminEmail> sent an email invitation to <N> users',
            adminEmail: 'user2@codebashing.com',
            totalUsers: 5,
            batchUuid: '1234567890',
        },
        {
            performedBy: {
                email: 'user2@codebashing.com',
                profilePictureUrl: 'https://picsum.photos/201',
            },
            action: 'logged_out',
            entity: 'user',
            time: new Date(),
            activity: '<userEmail> logged out',
            userEmail: 'user2@codebashing.com',
        },
    ],
    total: 8,
};
exports.mockGetBulkActivityUsers = {
    users: [
        {
            email: 'user1@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/200',
            fullName: 'User 1',
            confirmed: true,
        },
        {
            email: 'user2@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/201',
            fullName: 'User 2',
            confirmed: true,
        },
        {
            email: 'user3@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/202',
            fullName: 'User 3',
            confirmed: false,
        },
        {
            email: 'user4@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/203',
            fullName: 'User 4',
            confirmed: false,
        },
        {
            email: 'user5@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/204',
            fullName: 'User 5',
            confirmed: false,
        },
        {
            email: 'user6@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/205',
            fullName: 'User 6',
            confirmed: false,
        },
        {
            email: 'user7@codebashing.com',
            profilePictureUrl: 'https://picsum.photos/206',
            fullName: 'User 7',
            confirmed: true,
        },
        {
            email: 'user8@codebashing.com',
            confirmed: false,
        },
        {
            email: 'user9@codebashing.com',
            confirmed: false,
        },
        {
            email: 'user10@codebashing.com',
            confirmed: false,
        },
    ],
    total: 27,
};
